<template>
  <div class="board-message"><BoardMessageParts :obj="getMessage()" /></div>
</template>

<script>
import BoardMessageParts from './BoardMessageParts';
export default {
  name: 'BoardMessage',
  props: ['message'],
  components: { BoardMessageParts },
  methods: {
    getLines(message) {
      let result = message.match(/^([\s\S]*)(\r\n|\r|\n)([\s\S]*)/i);
      if (result) {
        return [
          ...this.getLines(result[1]),
          {
            type: 'br',
          },
          ...this.getLines(result[3]),
        ];
      } else {
        return [ { type: 'text', text: message } ];
      }
    },
    getLinks(message) {
      let result = message.match(/^([\s\S]*)\[link\s+(\d+)\s*\]([\s\S]*)/i);
      if (result) {
        return [
          ...this.getLinks(result[1]),
          {
            type: 'link',
            number: result[2],
          },
          ...this.getLinks(result[3]),
        ];
      } else {
        return this.getLines(message);
      }
    },
    getQuotes(message) {
      let result = message.match(/^([\s\S]*?)\[quote\s+(\d+)\s*\](\r\n|\r|\n)?([\s\S]*)\[\/quote\]([\s\S]*?)$/i);
      if (result) {
        return [
          ...this.getQuotes(result[1]),
          {
            type: 'quote',
            number: result[2],
            children: this.getQuotes(result[4]),
          },
          ...this.getQuotes(result[5]),
        ];
      } else {
        return this.getLinks(message);
      }
    },
    getMessage() {
      return this.getQuotes(this.message);
    },
  },
};
</script>

<style scoped>
</style>
